<div class="cds-mb-4">
  <cb-alert-banner
    [show]="errors().length > 0"
    [alertType]="'error'"
    (close)="(false)"
    data-testid="policy-coverage-error-alert-banner">
    @if (formattedError().length > 1) {
      <ol class="!cds-list-decimal !cds-list-inside cds-ml-1">
        @for (error of formattedError(); track error) {
          <li data-testid="policy-coverage-error-alert-banner-message">
            {{ error }}
          </li>
        }
      </ol>
    } @else {
      <p data-testid="policy-coverage-error-alert-banner-message">
        {{ formattedError()[0] }}
      </p>
    }
  </cb-alert-banner>
</div>
